export const AccountsEnums = Object.freeze({
  ACTIVE_TAB_EARNING: "earning",
  ACTIVE_TAB_EXPANSES: "expanses",
  FILTER_START_DATE: "startDate",
  FILTER_END_DATE: "endDate",
  FILTER_COMPANY: "company",
});
